import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createTask, updateTask, getAllTasks, deleteTask, getTaskById } from '../Api/taskApi';

// Async thunks
export const createTaskAsync = createAsyncThunk(
    'tasks/createTask',
    async (taskData) => {
        const response = await createTask(taskData);
        return response;
    }
);

export const updateTaskAsync = createAsyncThunk(
    'tasks/updateTask',
    async (taskData) => {
        const response = await updateTask(taskData);
        return response;
    }
);

export const deleteTaskAsync = createAsyncThunk(
    'tasks/deleteTask',
    async (taskId, { dispatch }) => {
        const response = await deleteTask(taskId);
        // Refresh tasks after deletion
        dispatch(fetchTasksAsync());
        return response;
    }
);

export const fetchTaskByIdAsync = createAsyncThunk(
    'tasks/fetchTaskById',
    async (taskId) => {
        const response = await getTaskById(taskId);
        console.log(response, 'response')
        return response;
    }
);

export const fetchTasksAsync = createAsyncThunk(
    'tasks/fetchTasks',
    async (userEmail = null) => {
        const response = await getAllTasks(userEmail);
        return response.tasks;
    }
);

const initialState = {
    tasks: [],
    currentTask: null,
    selectedTask: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null
};

const taskSlice = createSlice({
    name: 'tasks',
    initialState,
    reducers: {
        setCurrentTask: (state, action) => {
            state.currentTask = action.payload;
        },
        clearCurrentTask: (state) => {
            state.currentTask = null;
        },
        selectTask: (state, action) => {
            state.selectedTask = action.payload;
        },
        clearSelectedTask: (state) => {
            state.selectedTask = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Tasks
            .addCase(fetchTasksAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTasksAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.tasks = action.payload;
            })
            .addCase(fetchTasksAsync.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            // Fetch Task By ID
            .addCase(fetchTaskByIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTaskByIdAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.currentTask = action.payload;
            })
            .addCase(fetchTaskByIdAsync.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            // Create Task
            .addCase(createTaskAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createTaskAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.tasks = [...state.tasks, action.payload];
            })
            .addCase(createTaskAsync.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            // Update Task
            .addCase(updateTaskAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateTaskAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const index = state.tasks.findIndex(task => task.id === action.payload.id);
                if (index !== -1) {
                    state.tasks[index] = action.payload;
                }
            })
            .addCase(updateTaskAsync.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            // Delete Task
            .addCase(deleteTaskAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteTaskAsync.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(deleteTaskAsync.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

// Export actions and reducer
export const { 
    setCurrentTask, 
    clearCurrentTask, 
    selectTask,  
    clearSelectedTask  
} = taskSlice.actions;
export default taskSlice.reducer;

// Selectors
export const selectAllTasks = (state) => state.tasks.tasks;
export const selectTaskById = (state, taskId) => 
    state.tasks.tasks.find(task => task.id === taskId);
export const selectTasksStatus = (state) => state.tasks.status;
export const selectTasksError = (state) => state.tasks.error;
export const selectCurrentTask = (state) => state.tasks.currentTask;
export const selectSelectedTask = (state) => state.tasks.selectedTask;
